import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Accounts List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const accounts = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'accounts',
        params: payload && payload.params ? payload.params : null,
		isCancellable: true
	})
}

/** Definition of default accounts
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_accounts%7Bid%7Ddefault
*/
export const accountsDefault = ({ payload, id }) => {
	return httpClient({
		method: 'PUT',
		url: `accounts/${id}/default`,
		data: payload
	})
}

/** Definition of default accounts group
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_accountsgroupupdatedefault
*/
export const accountsGroupDefault = (payload) => {
	return httpClient({
		method: 'PUT',
		url: 'accounts/group/update/default',
		params: payload
	})
}

/** Account Visibility
@docs has no documentation
*/
export const accountsVisible = ({ params }) => {
	return httpClient({
		method: 'PUT',
		url: 'accounts/visible',
        data: params
	})
}

/** Sends a notification to email with movement info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_accounts%7Bid%7Dmovements%7BmovementId%7Dreceiptemail
*/
export const sendMovementEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/accounts/${payload.accountId}/movements/${payload.movementId}/receipt/email`,
        params: payload.params,
		data: payload.data
	})
}

/** Sends a notification to sms with movement info
@docs Não há documentação
*/
export const sendMovementSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/accounts/${payload.accountId}/movements/${payload.movementId}/receipt/sms`,
        params: payload.params,
		data: payload.data
	})
}

/** Sends a notification to email with account NBA/IBAN info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_accounts%7Bid%7Dsendinfoemail
*/
export const sendNbaIbanEmailNotification = payload => {
	return httpClient({
        method: 'POST',
        url: `/accounts/${payload.accountId}/sendinfo/email`,
        data: payload.data
    })
}

/** Sends a notification to sms with account NBA/IBAN info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_accounts%7Bid%7Dsendinfosms
*/
export const sendNbaIbanSMSNotification = payload => {
	return httpClient({
        method: 'POST',
        url: `/accounts/${payload.accountId}/sendinfo/sms`,
        data: payload.data
    })
}

/** Request Moviments
@docs
*/
export const requestMoviments = payload => {
	return httpClient({
		method: 'GET',
		url: `/accounts/${payload.accountId}/category/movement`,
		params: payload.params,
		isCancellable: true
	})
}

/** Request Moviment Detail
@docs
*/
export const requestMovimentDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `/accounts/${payload.accountId}/movements/${payload.movementId}/generic`,
        params: payload.params,
		isCancellable: true
	})
}

/** Request Movement Excel export URL
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dmovementsexport
*/
export const createMovementsExcelURL = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `accounts/${payload.accountId}/movements/export`,
		params: payload.params
	})
}

/** Request Moviment Detail Download Url
@docs
*/
export const requestMovementDetailDownloadUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `accounts/${payload.accountId}/movements/${payload.movementId}/receipt`,
		params: payload.params
	})
}

/** Request Movements Categories
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetaccountcategory
*/
export const requestMovementsCategories = () => {
	return httpClient({
		method: 'GET',
		url: '/accounts/category',
		isCancellable: true
	})
}

/** Request Update Movement Selected Category
@docs
*/
export const updateSelectedCategoryFetch = payload => {
	return httpClient({
		method: 'PUT',
		url: `/accounts/${payload.accountId}/category/movement/${payload.movementId}`,
		params: payload.queryParams,
		data: payload.body
	})
}

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const requestAccountsBalances = payload => {
	return httpClient({
		method: 'GET',
		url: 'accounts/balances',
		params: payload,
		isCancellable: true
	})
}

/** Request Account Details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dgeneric
*/
export const requestAccountDetails = payload => {
	return httpClient({
		method: 'GET',
		url: `accounts/${payload}/generic`,
		isCancellable: true
	})
}

/** Request Accounts Movements
@docs
*/
export const requestAccountsMovements = payload => {
	return httpClient({
		method: 'GET',
		url: `/accounts/${payload.accountId}/category/movement`,
		params: payload.params,
		isCancellable: true
	})
}

/** Request Moviments PDF Download Url
@docs
*/
export const requestMovementsPdfUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `accounts/${payload.accountId}/extract`,
		params: payload.params
	})
}

/** Creates the url to download excel for movements
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dmovementsexport
*/
export const createsDowloadMovementsExcelUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `accounts/${payload.accountId}/movements/export`,
		params: payload.params
	})
}

/** Request Update Account Description
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_accounts%7Bid%7D
*/
export const updateAccountDescription = payload => {
	return httpClient({
		method: 'PUT',
		url: `/accounts/${payload.accountId}`,
		data: payload.data
	})
}

/** Request to generate an extract to consult
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_accounts%7Bid%7Dextractgenerate
*/
export const generateExtract = payload => {
	return httpClient({
		method: 'POST',
		url: `accounts/${payload.accountId}/extract/generate`,
		params: payload.params,
		operationTypeId: 3011 /* for mocks handling of tokens */
	})
}

/** Request All Accounts and their plafonds and limits
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsplafondsandlimits
*/
export const requestAccountsPlafondsandlimits = payload => {
	return httpClient({
		method: 'GET',
		url: '/accounts/plafondsandlimits',
		isCancellable: true
	})
}

export const requestCashflowInfo = payload => {
	return httpClient({
		method: 'GET',
		url: '/accounts/category/movement/monthly',
		params: payload,
		isCancellable: true
	})
}

/** Request plafond from a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dplafond
*/
export const requestAccountsPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `/accounts/${payload.id}/plafond`,
		params: payload.params,
		isCancellable: true
	})
}

/** Request plafond from a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dtransactionlimit
*/
export const requestAccountsTransactionLimit = payload => {
	return httpClient({
		method: 'GET',
		url: `accounts/${payload.id}/transaction/limit`,
		params: payload.params,
		isCancellable: true
	})
}
